(function(){
    'use strict';

    angular.module('elogbooks.common.kpi-surveys', []);
})();
